import { InitialIntegrationReducer } from "../_services/store/InitialIntegrationReducer";
import { ConfigurationFieldNames } from "../_statics/ConfigurationStatics";
import { sortValuesByField } from "../../_services/sorting-helper";

export const INITIAL_NEW_CONFIGURATION = {
    [ConfigurationFieldNames.PLATFORM_CLIENT_UUID]: "",
};

const determineIntegrationScreenStateRequest = (state) => {
    state.errorMessage = null;
    state.isLoading = true;
    state.commons = null;
    state.configuration = null;
    state.editConfiguration = null;
    state.configurations = null;
};
const determineIntegrationScreenStateSuccess = (state, action) => {
    state.isLoading = false;
    state.commons = action.payload.commons;
    state.configurations = action.payload.configurations;
    state.warningMessage = action.payload.warningMessage ? action.payload.warningMessage : null;

};
const determineIntegrationScreenStateFailure = (state, action) => {
    state.isLoading = false;
    state.errorMessage = action.payload;
};

const determineImportScreenStateRequest = (state) => {
    state.errorMessage = null;
    state.isLoading = true;
    state.commons = null;
    state.configuration = null;
    state.editConfiguration = null;
    state.importSuccessMessage = null;
    state.importErrorMessage = null;
    state.advancedSettingsModal = false;
    state.updateErrorMessage = undefined;
};
const determineImportScreenStateSuccess = (state, action) => {
    state.isLoading = false;
    state.commons = action.payload.commons;
    state.configuration = action.payload.configuration;
    state.editConfiguration = action.payload.configuration;
};
const determineImportScreenStateFailure = (state, action) => {
    state.isLoading = false;
    state.errorMessage = action.payload;
};

const toggleCreateConfigurationModal = (state) => {
    state.createConfigurationModal = !state.createConfigurationModal;
    state.createErrorMessage = null;
    state.newConfiguration = {
        ...INITIAL_NEW_CONFIGURATION,
    };
};

const setNewConfiguration = (state, action) => {
    state.newConfiguration = action.payload;
};

const createNewConfigurationRequest = (state) => {
    state.submitted = true;
    state.isCreateLoading = true;
    state.createErrorMessage = null;
    state.warningMessage = null;
};
const createNewConfigurationSuccess = (state, action) => {
    let config = action.payload.response ? action.payload.response : action.payload;
    let configs = state.configurations;
    if (configs.length > 0) {
        configs = sortValuesByField([config, ...configs], ConfigurationFieldNames.PLATFORM_CLIENT_NAME);
    } else {
        configs = [config];
    }
    state.warningMessage = action.payload.warningMessage ? action.payload.warningMessage : null;
    state.submitted = false;
    state.isCreateLoading = false;
    state.createConfigurationModal = false;
    state.configurations = configs;
    state.newConfiguration = { ...INITIAL_NEW_CONFIGURATION };
};
const createNewConfigurationFailure = (state, action) => {
    state.submitted = false;
    state.isCreateLoading = false;
    state.createErrorMessage = action.payload;
    state.warningMessage = null;
};

const getConfigurationsOfOrganizationRequest = (state) => {
    state.isLoading = true;
    state.configuration = null;
    state.editConfiguration = null;
    state.errorMessage = null;
    state.successMessage = null;
};
const getConfigurationsOfOrganizationSuccess = (state, action) => {
    state.isLoading = false;
    state.errorMessage = null;
    state.configurations = action.payload;
};
const getConfigurationsOfOrganizationFailure = (state, action) => {
    state.isLoading = false;
    state.configurations = null;
    state.errorMessage = action.payload;
};

const getConfigurationRequest = (state) => {
    state.isLoading = true;
    state.configuration = null;
    state.editConfiguration = null;
    state.errorMessage = null;
    state.unsavedChanges = false;
    state.successMessage = null;
    state.importSuccessMessage = null;
    state.importErrorMessage = null;
};
const getConfigurationSuccess = (state, action) => {
    state.isLoading = false;
    state.configuration = action.payload;
    state.editConfiguration = action.payload;
    state.errorMessage = null;
};
const getConfigurationFailure = (state, action) => {
    state.isLoading = false;
    state.configuration = null;
    state.errorMessage = action.payload;
};

const setEditConfiguration = (state, action) => {
    state.editConfiguration = action.payload;
};
const setUnsavedChanges = (state, action) => {
    state.unsavedChanges = action.payload;
};
const toggleAdvancedSettingsModal = (state) => {
    state.advancedSettingsModal = !state.advancedSettingsModal;
    state.editConfiguration = state.configuration;
    state.successMessage = null;
    state.unsavedChanges = false;
};

const updateConfigurationRequest = (state) => {
    state.isUpdateLoading = true;
    state.updateErrorMessage = null;
    state.successMessage = null;
};
const updateConfigurationSuccess = (state, action) => {
    state.isUpdateLoading = false;
    state.configuration = action.payload;
    state.editConfiguration = action.payload;
    state.successMessage = "Speichern erfolgreich.";
    state.advancedSettingsModal = false;
    state.unsavedChanges = false;
};

const updateConfigurationFailure = (state, action) => {
    state.isUpdateLoading = false;
    state.updateErrorMessage = action.payload;
};

const toggleDeleteConfigurationModal = (state, action) => {
    state.configurationToBeDeleted = action.payload;
    state.deleteConfigurationModal = !state.deleteConfigurationModal;
    state.isDeleteLoading = false;
};
const deleteConfigurationRequest = (state) => {
    state.isDeleteLoading = true;
    state.deleteErrorMessage = null;
};

const deleteConfigurationSuccess = (state) => {
    state.configurations = state.configurations.filter((config) => {
        return config.externalUUID !== state.configurationToBeDeleted.externalUUID;
    });
    state.configurationToBeDeleted = null;
    state.deleteConfigurationModal = false;
    state.isDeleteLoading = false;
};
const deleteConfigurationFailure = (state, action) => {
    state.isDeleteLoading = false;
    state.deleteErrorMessage = action.errorMessage;
};

const triggerImportRequest = (state) => {
    state.importErrorMessage = null;
    state.successMessage = null;
    state.isImportLoading = true;
};
const triggerImportSuccess = (state, action) => {
    state.configuration = action.payload;
    state.editConfiguration = action.payload;
    state.importErrorMessage = null;
    state.isImportLoading = false;
    state.importSuccessMessage = "Der Import wurde erfolgreich gestartet";
};
const triggerImportFailure = (state, action) => {
    state.importErrorMessage = action.payload;
    state.isImportLoading = false;
    state.importSuccessMessage = null;
};

const unlockImportTriggerRequest = (state) => {
    state.unlockImportTriggerErrorMessage = null;
    state.unlockImportTriggerLoading = true;
};

const unlockImportTriggerSuccess = (state, action) => {
    state.unlockImportTriggerLoading = false;
    state.configuration = action.payload;
    state.editConfiguration = action.payload;
};

const unlockImportTriggerFailure = (state, action) => {
    state.unlockImportTriggerErrorMessage = action.payload;
    state.unlockImportTriggerLoading = false;
};

const unlockPrapTriggerRequest = (state) => {
    state.unlockPrapTriggerErrorMessage = null;
    state.unlockPrapTriggerLoading = true;
};

const unlockPrapTriggerSuccess = (state, action) => {
    state.unlockPrapTriggerLoading = false;
    state.configuration = action.payload;
    state.editConfiguration = action.payload;
};

const unlockPrapTriggerFailure = (state, action) => {
    state.unlockPrapTriggerErrorMessage = action.payload;
    state.unlockPrapTriggerLoading = false;
};

const searchConfigurationsFromProdRequest = (state) => {
    state.searchConfigurationsFromProdLoading = true;
    state.searchConfigurationsFromProdErrorMessage = null;
    state.productionConfigurations = [];
};

const searchConfigurationsFromProdSuccess = (state, action) => {
    state.searchConfigurationsFromProdLoading = false;
    state.productionConfigurations = action.payload;
};

const searchConfigurationsFromProdFailure = (state, action) => {
    state.searchConfigurationsFromProdLoading = false;
    state.searchConfigurationsFromProdErrorMessage = action.payload;
};

const resetSearchConfigurationsFromProd = (state) => {
    state.searchConfigurationsFromProdLoading = false;
    state.searchConfigurationsFromProdErrorMessage = null;
    state.productionConfigurations = [];
};

const autoUpdateFromProdRequest = (state) => {
    state.autoUpdateFromProdLoading = true;
    state.autoUpdateFromProdErrorMessage = null;
};

const autoUpdateFromProdSuccess = (state) => {
    state.autoUpdateFromProdLoading = false;
};

const autoUpdateFromProdFailure = (state, action) => {
    state.autoUpdateFromProdLoading = false;
    state.autoUpdateFromProdErrorMessage = action.payload;
};

const setGoldStandardOptions = (state, action) => {
    state.goldStandardOptions = action.payload;
};

const toggleCloneConfigurationModal = (state, action) => {
    state.configurationToBeCloned = action.payload;
    state.cloneConfigurationModal = !state.cloneConfigurationModal;
    state.cloneErrorMessage = null;
    state.cloneSuccessMessage = null;
    // Reset per-modal selections so a re-open starts clean
    state.cloneSourceConfigurations = [];
    state.cloneSourceConfigsLoading = false;
};

const setCloneOrganizations = (state, action) => {
    state.cloneOrganizations = action.payload;
};

const setCloneSourceOrganizationConfigurations = (state, action) => {
    state.cloneSourceConfigurations = action.payload;
};

const setCloneSourceConfigsLoading = (state, action) => {
    state.cloneSourceConfigsLoading = action.payload;
};

const cloneConfigurationRequest = (state) => {
    state.isCloneLoading = true;
    state.cloneErrorMessage = null;
    state.cloneSuccessMessage = null;
};

const cloneConfigurationSuccess = (state, action) => {
    const updated = action.payload;
    state.isCloneLoading = false;
    state.cloneConfigurationModal = false;
    state.configurationToBeCloned = null;
    state.cloneSuccessMessage = "Konfiguration erfolgreich übernommen.";
    state.configurations = state.configurations.map((config) =>
        config.externalUUID === updated.externalUUID ? updated : config
    );
};

const cloneConfigurationFailure = (state, action) => {
    state.isCloneLoading = false;
    state.cloneErrorMessage = action.payload;
};

const resetState = () => {
    return {
        ...new InitialIntegrationReducer(),
    };
};

export const integrationReducerActions = {
    // Basics
    determineIntegrationScreenStateRequest,
    determineIntegrationScreenStateSuccess,
    determineIntegrationScreenStateFailure,

    determineImportScreenStateRequest,
    determineImportScreenStateSuccess,
    determineImportScreenStateFailure,

    // Create
    toggleCreateConfigurationModal,
    setNewConfiguration,
    createNewConfigurationRequest,
    createNewConfigurationSuccess,
    createNewConfigurationFailure,

    // Read
    getConfigurationsOfOrganizationRequest,
    getConfigurationsOfOrganizationSuccess,
    getConfigurationsOfOrganizationFailure,

    getConfigurationRequest,
    getConfigurationSuccess,
    getConfigurationFailure,

    // Update
    setEditConfiguration,
    setUnsavedChanges,
    toggleAdvancedSettingsModal,

    updateConfigurationRequest,
    updateConfigurationSuccess,
    updateConfigurationFailure,

    // Delete
    toggleDeleteConfigurationModal,
    deleteConfigurationRequest,
    deleteConfigurationSuccess,
    deleteConfigurationFailure,

    triggerImportRequest,
    triggerImportSuccess,
    triggerImportFailure,

    unlockImportTriggerRequest,
    unlockImportTriggerSuccess,
    unlockImportTriggerFailure,

    unlockPrapTriggerRequest,
    unlockPrapTriggerSuccess,
    unlockPrapTriggerFailure,

    searchConfigurationsFromProdRequest,
    searchConfigurationsFromProdSuccess,
    searchConfigurationsFromProdFailure,
    resetSearchConfigurationsFromProd,

    autoUpdateFromProdRequest,
    autoUpdateFromProdSuccess,
    autoUpdateFromProdFailure,

    // Clone
    setGoldStandardOptions,
    setCloneOrganizations,
    toggleCloneConfigurationModal,
    setCloneSourceOrganizationConfigurations,
    setCloneSourceConfigsLoading,
    cloneConfigurationRequest,
    cloneConfigurationSuccess,
    cloneConfigurationFailure,

    resetState,
};
